import { Vue } from 'vue-property-decorator';

import ModalEnum from '@/ship/Enums/ModalEnum';
import { WeeklyReportEnum } from '@/ship/Enums/ProjectManagementEnums';
import IFile from '@/ship/Models/IFile';
import { IPMChart, IPMChartWeeklyReport, IPMChartWeeklyReportTask } from '@/ship/Models/IProjectManagement';
import Project from '@/ship/Models/Project';
import User from '@/ship/Models/User';
import { GetRequestParams } from '@/ship/Requests/RequestParams';
import {
    ProjectManagementAction,
    ProjectManagementMutation,
    ProjectManagementState,
} from '@/store/ProjectManagement/ProjectManagementRoot';
import { updatePhotoWeeklyReport } from '@/utils/api/ProjectManagement/PMChart';
import ErrorService from '@/utils/ErrorService';
import { Action, State } from 'vuex-class';

export default class WeeklyReportMixin extends Vue {
    @Action GET_PROJECT!: (id: number) => Promise<Project>;
    @State project!: Project;
    @State user!: User;
    @ProjectManagementAction GET_CHART_BY_ID!: (params: { id: number; params?: GetRequestParams }) => Promise<IPMChart>;
    @ProjectManagementAction GET_WEEKLY_REPORT!: (id: number) => Promise<IPMChartWeeklyReport>;
    @ProjectManagementMutation SET_WEEKLY_REPORT!: (weeklyReport: IPMChartWeeklyReport) => void;
    @ProjectManagementState chart!: IPMChart;
    @ProjectManagementState weeklyReport!: IPMChartWeeklyReport;

    weeklyReportTasks: IPMChartWeeklyReportTask[] = [];
    readonly prefix = 'page.projectManagement';
    readonly requestParams: GetRequestParams = {
        include: 'photo1,photo2,photo3,photo4,photo_general_plan,tasks.photo,tasks.childTasks.photo',
    };

    /**
     * id графика
     * @returns {number}
     */
    get chartId(): number {
        const id = this.$route.params.id;
        return Number(id);
    }

    /**
     * id отчета
     * @returns {number}
     */
    get reportId(): number {
        const id = this.$route.params.docId;
        return Number(id);
    }

    get reportStatus() {
        return this.weeklyReport?.approvalStage;
    }

    get canEditReport() {
        return this.weeklyReport.approvalStage === WeeklyReportEnum.CompiledBySupervisor;
    }

    setWeeklyReport(event: any) {
        this.SET_WEEKLY_REPORT(event);
    }

    uploadImageHandler(photoNumber: number) {
        this.$modal.show(ModalEnum.PhotoUploader, {
            actionCallback: (file: IFile) => this.updateImageRequest(file, photoNumber),
        });
    }

    deleteImageHandler(photoNumber: number) {
        this.$modal.show(ModalEnum.Danger, {
            title: 'Вы действительно хотите удалить изображение?',
            acceptLabel: 'Удалить',
            onAccept: () => this.updateImageRequest(null, photoNumber),
        });
    }

    async updateImageRequest(photo: IFile | null, photoNumber: number) {
        try {
            const response = await updatePhotoWeeklyReport(
                this.reportId,
                {
                    photo_id: photo ? photo.id : null,
                    photo_number: photoNumber,
                },
                this.requestParams,
            );

            this.setWeeklyReport(response.data.data);
        } catch (error) {
            ErrorService.handleApiError(error);
        }
    }
}
